import api from './api'

const headers = {
  "Access-Control-Allow-Origin": "*",
  "Content-Type": "application/json",
  Accept: "application/json"
}

class LicencasAPI {
  async getListaGruposLicencas() {
    return await api.get("/get_lista_grupos_licencas", { headers })
  }

  async limparCache() {
    return await api.get("/limpar_cache", { headers })
  }
}

export default new LicencasAPI()
